export const expenses = [
  { value: 'transport', label: 'Transport' },
  { value: 'products', label: 'Products' },
  { value: 'health', label: 'Health' },
  { value: 'alcohol', label: 'Alcohol' },
  { value: 'entertainment', label: 'Entertainment' },
  { value: 'housing', label: 'Housing' },
  { value: 'technique', label: 'Technique' },
  { value: 'communal,communication', label: 'Communal, Communication' },
  { value: 'sports,hobbies', label: 'Sports, Hobbies' },
  { value: 'education', label: 'Education' },
  { value: 'other', label: 'Other' },
];

export const incomes = [
  { value: 'Salary', label: 'Salary' },
  { value: 'Additional income', label: 'Additional Income' },
];
